import { SubwayEntity } from '@components/Wizard/components/Subway/SubwayEntity';
import { styled } from '@mui/material';

export const StyledSubwayEntity = styled(SubwayEntity)<{
  disabled?: boolean;
}>(({ theme, disabled }) => ({
  position: 'relative',
  pointerEvents: disabled ? 'none' : 'auto',
  borderTop: `1px solid ${theme.palette.grey[9]}`,
}));
